
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EngagementXhsPostMetricsForInsight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementXhsPostMetricsForInsight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"insightUrls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"likes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"saves"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageViewDurationSeconds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newFollowers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewsFromHome"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewsFromProfile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewsFromSearch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewsFromFollowing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewsFromOther"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"malePercentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"femalePercentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ageUp17Percentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"age1824Percentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"age2534Percentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"age3544Percentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"age45UpPercentage"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":512}};
    doc.loc.source = {"body":"query EngagementXhsPostMetricsForInsight($postId: Int!) {\n  engagementXhsPostMetricsForInsight(postId: $postId) {\n    id\n    postContent\n    status\n    insightUrls\n    likes\n    comments\n    saves\n    views\n    averageViewDurationSeconds\n    newFollowers\n    viewsFromHome\n    viewsFromProfile\n    viewsFromSearch\n    viewsFromFollowing\n    viewsFromOther\n    malePercentage\n    femalePercentage\n    ageUp17Percentage\n    age1824Percentage\n    age2534Percentage\n    age3544Percentage\n    age45UpPercentage\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["EngagementXhsPostMetricsForInsight"] = oneQuery(doc, "EngagementXhsPostMetricsForInsight");
        
